import { updateCheckoutSession } from '@otter-ai/recall-client';
import { PurchaseApplyCouponEvent, trackEvent } from '@otter-ai/telemetry';
import { useCheckout } from '@stripe/react-stripe-js';
import { useMutation } from '@tanstack/react-query';
import { useSetAtom } from 'jotai';
import { couponIsUpdatingAtom } from '#atoms';

type ApplyCouponParams = {
  couponCode: string;
};

export const useApplyCoupon = () => {
  const { runServerUpdate, id } = useCheckout();
  const setIsCouponUpdating = useSetAtom(couponIsUpdatingAtom);

  const applyCouponMutation = useMutation<boolean, Error, ApplyCouponParams>({
    mutationFn: async ({ couponCode }: ApplyCouponParams) => {
      await runServerUpdate(() =>
        updateCheckoutSession({
          body: {
            checkout_session_id: id,
            session_params: {
              discounts: [{ coupon: couponCode }],
            },
          },
          throwOnError: true,
        }),
      );

      return true;
    },
    onSuccess: (__, variables) => {
      trackEvent(
        PurchaseApplyCouponEvent({
          CouponCode: variables.couponCode,
          Status: 'success',
        }),
      );
    },
    onError: (error, variables) => {
      trackEvent(
        PurchaseApplyCouponEvent({
          CouponCode: variables.couponCode,
          Status: 'failure',
          ErrorMessage: error.message,
        }),
      );
    },
    onMutate: () => {
      setIsCouponUpdating(true);
    },
    onSettled: () => {
      setIsCouponUpdating(false);
    },
  });

  return applyCouponMutation;
};
